module.exports = __webpack_public_path__ + "fonts/golbantradeecommd.e46c8e0.otf";